import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-close-chip',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './close-chip.component.html',
})
export class CloseChipComponent {
  @Output() closed = new EventEmitter<void>();
}
